import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import "../../../styles/assets/css/pages/patient_contract.css";
import ReactPlayer from "react-player";

class TutorialVideo extends Component {
  constructor() {
    super()
    this.state = {
        title: '',
        video: '',
    }
  }

  componentDidMount() {
    const vid = this.props.match.params.vid
    var title = ''
    var video = ''
    if(vid == 1) {
      title = 'Intro to FITT-BD'
      video = 'Intro_to_FITT-BD_Video.mp4'
    } else if(vid == 2) {
      title = 'Intro to FITT-BD Dashboard'
      video = 'Intro_to_FITT-BD_Dashboard.mp4'
    } else if(vid == 3) {
      title = 'Intro to Patient Contract'
      video = 'Intro_to_Patient_Contract.mp4'
    }
    this.setState( {
      title: title,
      video: video,
    })
  }

  render() {
    return (
      <div className="patient_contract_list box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">{this.state.title}</div>
        </div>
        <div className="row">
          <div className="small-12 columns">
          <video controls
            style={{ width: "100%", height: "auto" }}
            preload="metadata" playsInline >
            <source src={"/videos/"+this.state.video} type="video/mp4" />
          </video>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({ type: "LOAD_USER_AUTH", payload: response });
  },
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TutorialVideo)
